export default __webpack_public_path__ + "static/media/govt-college-logo.6f1e9683.png";